import React, { Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LeadCaptureProvider } from "@/contexts/LeadCaptureContext";
import LeadCaptureModal from "@/components/LeadCaptureModal";
import Home from "./pages/Home";
import Index from "./pages/Index";
import AIChat from "./pages/AIChat";
import RegistroCliente from "./pages/RegistroCliente";
import CadastroSucesso from "./pages/CadastroSucesso";
import ContratoFormalPage from "./pages/ContratoFormalPage";
import TermoView from "./pages/TermoView";
import ContratoView from "./pages/ContratoView";
import ConfigurarPlano from "./pages/ConfigurarPlano";
import Pagamento from "./pages/Pagamento";
import CheckoutSuccess from "./pages/CheckoutSuccess";
import CheckoutCancel from "./pages/CheckoutCancel";
import CheckoutExpired from "./pages/CheckoutExpired";
import NotFound from "./pages/NotFound";
import Ofertas from "./pages/Ofertas";
import PlanosFlex from "./pages/PlanosFlex";
import PoliticaDePrivacidade from "./pages/PoliticaDePrivacidade";
import TermosDeUso from "./pages/TermosDeUso";
import CalculadoraROI from "./pages/CalculadoraROI";
const AdminApp = React.lazy(() => import("./admin/AdminApp"));

const queryClient = new QueryClient();

const App = () => (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <LeadCaptureProvider>
          <Toaster />
          <Sonner />
          <LeadCaptureModal />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/planos" element={<Index />} />
              <Route path="/chat" element={<AIChat />} />
              <Route path="/chat/:id" element={<AIChat />} />
              <Route path="/registro-cliente" element={<RegistroCliente />} />
              <Route path="/cadastro-sucesso" element={<CadastroSucesso />} />
              <Route path="/contrato-formal/:adhesionId" element={<ContratoFormalPage />} />
              <Route path="/termo/:adhesionId" element={<TermoView />} />
              <Route path="/contrato/:draftId" element={<ContratoView />} />
              <Route path="/configurar" element={<ConfigurarPlano />} />
              <Route path="/pagamento" element={<Pagamento />} />
              <Route path="/ofertas" element={<Ofertas />} />
              <Route path="/planos-flex" element={<PlanosFlex />} />
              <Route path="/politica-de-privacidade" element={<PoliticaDePrivacidade />} />
              <Route path="/termos-de-uso" element={<TermosDeUso />} />
              <Route path="/calculadora-roi" element={<CalculadoraROI />} />
              <Route path="/checkout-success" element={<CheckoutSuccess />} />
              <Route path="/checkout-cancel" element={<CheckoutCancel />} />
              <Route path="/checkout-expired" element={<CheckoutExpired />} />
              <Route path="/admin/*" element={
                <Suspense fallback={<div>Carregando painel admin...</div>}>
                  <AdminApp />
                </Suspense>
              } />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </LeadCaptureProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

export default App;
